<template>
  <div class="table">
    <a-modal v-model="visible" title="延期记录" width="740px" :footer="null" :destroyOnClose='true'
      @cancel="form.page = 1;">
      <div class="input" style="margin-bottom:20px;">
        <b>进度筛选：</b>
        <a-select v-model="form.step" placeholder="请选择" style="width:200px;margin-left:20px;">
          <a-select-option value=''>全部</a-select-option>
          <a-select-option :value='i.step' v-for='(i, key) in Step' :key='key'>{{ i.title }}</a-select-option>
        </a-select>
        <div class="rt" style="float:right;">
          <a-button icon="search" @click="getList">查询</a-button>
        </div>
      </div>
      <a-table :columns="columns" :data-source="lists" :loading="loading" :pagination='false' class="tablebox">
        <div slot="create_time" slot-scope="text, record">
          {{ record.create_time | yearFormat }}
        </div>
        <div slot="alist" slot-scope="text, record" v-if='record'>
          <Normap :tit='record.reason'></Normap>
        </div>
      </a-table>
      <div style="text-align:center;padding-top:20px;" v-if='totalLength > 10'>
        <a-pagination :total="totalLength" show-quick-jumper show-less-items @change='turn' />
      </div>
    </a-modal>
  </div>
</template>
<script>
import { overLists } from "@/server/api"
// import Step from '@/page/ly/liteKey.json'
const columns = [
  { title: '操作时间', dataIndex: 'create_time', width: 140, scopedSlots: { customRender: 'create_time' }, },
  { title: '延期进度', dataIndex: 'step_title', width: 120 },
  { title: '延期天数', dataIndex: 'day', width: 120 },
  { title: '操作人', dataIndex: 'userName', width: 120 },
  { title: '延期原因', dataIndex: 'reason', width: 200, scopedSlots: { customRender: 'alist' }, },
];

export default {
  name: 'InvalidTable',
  props: ["Step"],
  data() {
    return {
      // Step,
      columns,
      visible: false,
      list: [],
      count: 0,
      form: {
        step: '',
        limit: 5,
        page: 1,
      },
      totalLength: 0,
      loading: true,
      lists: []
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.getList()
      }
    }
  },
  // created() {
  //   this.getList()
  // },
  methods: {
    turn(val) {
      this.form.page = val
      this.updatePageData()
    },
    updatePageData() {
      const start = (this.form.page - 1) * 10
      const end = start + 10
      this.lists = this.list.slice(start, end)
    },
    getList() {
      this.loading = true;
      overLists(Object.assign(this.form, { cause_id: this.$store.state.cause.id })).then(e => {
        this.list = e.list
        this.totalLength = e.list.length
        this.updatePageData()
        this.loading = false;
      })
    },
  }
}
</script>
<style lang="less" scoped>
.tablebox {
  min-height: 500px;
}
</style>